import React from "react";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { useTranslation } from "react-i18next";
import {
  ConfirmStepIcon,
  DateStepIcon,
  DetailsStepIcon,
  InviteStepIcon,
  RuleStepIcon,
} from "../../../assets/icons/MUI/EventsIcons";
import { colors } from "../../../theme/palette";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#008B07",
    borderWidth: 1,
  },
  ["& .MuiStepLabel-label"]: {
    color: colors.Dark1000,
    textAlign: "center",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
}));

const CustomStepIconRoot = styled("div")<{ isLastStep: boolean }>(({ isLastStep }) => ({
  backgroundColor: isLastStep ? "none" : "#FFF",
  border: isLastStep ? "none" : "1px solid #008B07",
  zIndex: 1,
  color: "#fff",
  width: 30,
  height: 30,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));

function CustomStepIcon({ icon, index, stepsLength }: { icon: any; index: number; stepsLength: number }) {
  const icons: { [index: string]: React.ReactElement } = {
    1: <RuleStepIcon />,
    2: <DetailsStepIcon />,
    3: <DateStepIcon />,
    4: <InviteStepIcon />,
    5: <ConfirmStepIcon />,
  };

  const isLastStep = index === stepsLength - 1;

  return <CustomStepIconRoot isLastStep={isLastStep}>{icons[String(icon)]}</CustomStepIconRoot>;
}

const CustomStepper = () => {
  const { t } = useTranslation();

  const steps = [
    t("pages.events.createEvent.understandRules"),
    t("pages.events.createEvent.fillDetails"),
    t("pages.events.createEvent.selectDateTime"),
    t("pages.events.createEvent.inviteFriends"),
    t("pages.events.createEvent.confirmPlayers"),
  ];

  return (
    <Stepper alternativeLabel activeStep={steps.length - 1} connector={<CustomConnector />}>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(props) => <CustomStepIcon {...props} index={index} stepsLength={steps.length} />}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CustomStepper;
